export default __webpack_public_path__ + "static/media/pic6.e9d1c388.jpg";